(() => {
  const desktop = () => matchMedia('(min-width:761px)').matches;
  const header = document.querySelector('body > header');
  const scope = document.querySelector('.sg-global-takeovers');
  if (!header || !scope) return;

  const definitions = [
    { key: 'arrivals', href: '/collections/new-arrivals' },
    { key: 'designer', href: '/pages/designers' },
    { key: 'consign', href: '/pages/consign-designer-clothing-san-francisco' }
  ];
  const controllers = [];

  definitions.forEach(({ key, href }) => {
    const trigger = header.querySelector(`.site-nav.style--classic a[href="${href}"]`);
    const menu = scope.querySelector(`[data-sg-${key}-menu]`);
    const close = scope.querySelector(`[data-sg-${key}-close]`);
    if (!trigger || !menu || !close) return;

    trigger.setAttribute(`data-sg-${key}-trigger`, '');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', menu.id);
    trigger.setAttribute('aria-expanded', 'false');
    const bodyClass = `sg-${key}-menu-open`;
    let suppressFocusOpen = false;

    const closeMenu = (restore = false) => {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(bodyClass);
      if (restore) {
        suppressFocusOpen = true;
        trigger.focus();
        requestAnimationFrame(() => { suppressFocusOpen = false; });
      }
    };
    const openMenu = () => {
      if (!desktop()) return;
      controllers.forEach(controller => { if (controller.close !== closeMenu) controller.close(); });
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add(bodyClass);
    };

    controllers.push({ close: closeMenu });
    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('focus', () => { if (!suppressFocusOpen) openMenu(); });
    trigger.addEventListener('click', event => {
      if (!desktop()) return;
      event.preventDefault();
      openMenu();
      close.focus();
    });
    close.addEventListener('click', () => closeMenu(true));
    menu.addEventListener('mouseleave', event => {
      if (event.relatedTarget && !trigger.contains(event.relatedTarget)) closeMenu(false);
    });
  });

  window.addEventListener('blur', () => controllers.forEach(controller => controller.close()));
  document.addEventListener('mouseout', event => {
    if (!event.relatedTarget) controllers.forEach(controller => controller.close());
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' || event.key === 'Esc') controllers.forEach(controller => controller.close(true));
  });
  window.addEventListener('resize', () => {
    if (!desktop()) controllers.forEach(controller => controller.close());
  });

  const grid = scope.querySelector('.sg-designer-more-logos');
  if (grid) {
    [...grid.querySelectorAll('a[data-stock][data-tier]')]
      .sort((a, b) => Number(a.dataset.tier) - Number(b.dataset.tier) || Number(b.dataset.stock) - Number(a.dataset.stock) || a.textContent.localeCompare(b.textContent))
      .forEach(tile => grid.appendChild(tile));
  }
})();
